<template>
  <div class="buy-container">
    <div class="buy-info">
      <h2 v-html="collection.title_html" />
      <h3>{{ collection.rarity_tier_title_1 }}</h3>
      <div class="buy-display small-buy-display">
        <video-player
          v-if="hasVideo && selectedDropImage === collection.roadmap_image_1"
          :src="collection.roadmap_video_1"
          controls
          fluid
        />
        <div v-else class="main-display"><img :src="selectedDropImage"></div>
        <div class="preview-container">
          <div class="preview" @click="selectDropImage(collection.roadmap_image_1)"><img :class="{'selected': selectedDropImage == collection.roadmap_image_1}" :src="collection.roadmap_image_1"></div>
          <div class="preview" @click="selectDropImage(collection.roadmap_image_2)"><img :class="{'selected': selectedDropImage == collection.roadmap_image_2}" :src="collection.roadmap_image_2"></div>
          <div class="preview" @click="selectDropImage(collection.roadmap_image_3)"><img :class="{'selected': selectedDropImage == collection.roadmap_image_3}" :src="collection.roadmap_image_3"></div>
        </div>
      </div>
      <div>
        <span class="number">{{ collection.series_number }}</span><span class="series">{{ collection.series }}</span>
      </div>
      <div class="description" v-html="collection.description_html" />
      <div class="price">
        <div class="price-display"><CurrentPrice :collection="collection" /></div>
      </div>
      <div class="museum-info">
        <div class="text" v-html="collection.utility_info_text_1_html" />
        <div class="text" v-html="collection.utility_info_text_2_html" />
        <div class="text" v-html="collection.utility_info_text_3_html" />
      </div>
      <div class="buy-now">
        <BuyButton :collection="collection" />
        <div v-if="collection.status == 'premint_sale'" class="buy-now__total">{{collection.edition_supply}} sets available</div>
        <div v-else class="buy-now__total">{{collection.edition_supply}} pieces total</div>
      </div>
      <BuyError />
    </div>

    <div class="buy-display large-buy-display">
      <video-player
          v-if="hasVideo && selectedDropImage === collection.roadmap_image_1"
          :src="collection.roadmap_video_1"
          controls
          fluid
        />
        <div v-else class="main-display"> <img :src="selectedDropImage"></div>
      <div class="preview-container"> 
        <div class="preview" @click="selectDropImage(collection.roadmap_image_1)"><img :class="{'selected': selectedDropImage == collection.roadmap_image_1}" :src="collection.roadmap_image_1"></div>
        <div class="preview" @click="selectDropImage(collection.roadmap_image_2)"><img :class="{'selected': selectedDropImage == collection.roadmap_image_2}" :src="collection.roadmap_image_2"></div>
        <div class="preview" @click="selectDropImage(collection.roadmap_image_3)"><img :class="{'selected': selectedDropImage == collection.roadmap_image_3}" :src="collection.roadmap_image_3"></div>
        <div v-if="collection.roadmap_title_4">
          <a href="#from-the-floor"><span class="arrow-down">&darr;</span> See it on the studio floor</a>
        </div>
      </div>
    </div>

  </div>

  <div v-if="collection.roadmap_title_4" id="from-the-floor" class="large-display">
    <img :src="collection.roadmap_image_4">
    <div class="large-display__container">
      <div class="large-display__container__text">
        <div class="title">
          {{ collection.roadmap_title_4 }}
        </div>
        <div class="desc">
          {{ collection.roadmap_description_4 }}
        </div>
      </div>
    </div>
  </div>

  <div class="what-you-get">
    <div class="wyg-headers">
      <div class="wyg-header-1">What you get</div>
      <div class="wyg-header-2">
        <h3>{{collection.wyg_title}}</h3>
        <div class="desc">{{collection.wyg_desc}}</div>
      </div>
    </div>
    <div class="wyg-physical">
      <div class="container">
        <div class="align-center">
          <div class="icon-container">
            <img class="icon" src="@/assets/icons/icon-number-1.svg">
          </div>
          <p class="sub-title">{{ collection.sub_header_1 }}</p>
        </div>
        <div class="art">
          <img :src="collection.nft_image_1" loading="lazy">
        </div>
        <p class="text-secondary">{{ collection.nft_title_1 }}</p>
      </div>
    </div>
    <div class="wyg-digital">
      <div class="container">
        <div class="align-center">
          <div class="icon-container">
            <img class="icon" src="@/assets/icons/icon-number-2.svg">
          </div>
          <p class="sub-title">{{ collection.sub_header_2 }}</p>
        </div>
        <div class="art">
          <img :src="collection.nft_image_2" loading="lazy">
        </div>
        <p class="text-secondary">{{ collection.nft_title_2 }}</p>
      </div>
    </div>
  </div>

  <div class="about">
    <div class="about-art">
      <div class="title">About the Art</div>
      <div class="item">
        <div class="label">Materials</div> <div class="value" v-html="collection.utility_info_text_1_html" />
      </div>
      <div class="item">
        <div class="label">Date</div> <div class="value" v-html="collection.utility_info_text_2_html" />
      </div>
      <div class="item">
        <div class="label">Size</div> <div class="value" v-html="collection.utility_info_text_3_html" />
      </div>
      <div class="item">
        <div class="label">History</div> <div class="value" v-html="collection.utility_info_text_4_html" />
      </div>
    </div>
    <div class="about-artist">
      <div class="title">About the Artist</div>
      <div class="text">
        {{ collection.partner_about }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BuyButton from '@/components/pollock/buy/BuyButton.vue'
import CurrentPrice from '@/components/pollock/item/CurrentPrice.vue'
import BuyError from './buy/BuyError.vue'
import { VideoPlayer } from '@videojs-player/vue'
import 'video.js/dist/video-js.css'


export default {
  components: {
    BuyButton,
    CurrentPrice,
    BuyError,
    VideoPlayer,
},
  props: ['collection'],
  data: () => ({
    validDrop: true
  }),
  computed: mapState({
    selectedDropImage: state => state.drops.selectedDropImage,
    hasVideo: state => !!state.drops.dropDetail.roadmap_video_1
  }),
  methods: {
    ...mapActions('drops', ['selectDropImage'])
  }
}
</script>

<style scoped lang="scss">
  .buy-container {
    display: flex;
    gap: 1.5em;
    @include container-sizer;
    margin-top: 1em;
    @include on-tablet {
      margin-top: 2em;
    }
  }

  h2 {
    font-family: $font-family-primary;
    font-size: 1.6em;
    margin: 0.5em 0;
    @include on-tablet {
      font-size: 1.8em;
      margin: 0.3em 0;
    }
    @include on-laptop {
      font-size: 2.3em;
      margin: 0.3em 0;
    }
  }

  h3 {
    font-family: $font-family-secondary;
    font-weight: normal;
    font-size: .8em;
    text-transform: uppercase;
    color: #888;
    @include on-laptop {
      font-size: 1em;
    }
  }

  hr {
    border-top: 0 solid #bbb;
  }

  .number {
    color: white;
    background-color: black;
    padding: 0.2em 0.4em;
    font-size: 0.6em;
  }

  .series {
    font-family: $font-family-secondary;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.6em;
    margin-left: 1em;
  }

  .description {
    margin: 1em 0;
    font-family: $font-family-primary;
    font-size: .8em;
    line-height: 1.2;
    @include on-tablet {
      margin: 1.2em 0;
      font-size: .9em;
    }
    @include on-laptop {
      margin: 1.5em 0;
      font-size: 1em;
    }
  }

  .price {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;

    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    font-family: $font-family-secondary;

    margin-bottom: 1em;
    padding: 12px 0;
    gap: .7em;

    @include on-laptop {
      padding: 14px 0;
      gap: .9em;
    }

    @include on-laptop {
      padding: 16px 0;
      gap: 1.1em;
    }
  }

  .museum-info {
    font-family: $font-family-primary;
    font-weight: normal;
    color: #888;
    font-size: 0.8em;
    border-bottom: 1px solid #eee;
    padding-bottom: 1em;
  }

  .museum-info  {
    > .text:first-child {
     font-weight: bold;
    }
  }
  .text {
    padding: .1em;
    @include on-tablet {
      padding: .2em 0;
    }
    @include on-laptop {
      padding: .35em 0;
    }
  }

  .buy-now {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    align-items: baseline;
    margin-top: .9em;
    gap: 1em;
    @include on-tablet {
      margin-top: 1.2em;
    }
    @include on-laptop {
      gap: 1.5em;
      margin-top: 1.5em;
    }
  }

  .buy-now__total {
    font-family: $font-family-secondary;
    font-size: 0.8em;
    font-weight: bold;
    text-transform: uppercase;
  }

  .buy-info, .buy-display {
    width: 100%;
    @include on-tablet {
      width: 50%;
    }
  }

  .buy-display {
    text-align: center;
    a {
      color: black;
      text-decoration: none;
      font-size: 12px;
      font-family: $font-family-secondary;
      text-transform: uppercase;
    }
    &.large-buy-display {
      display: none;
      @include on-tablet {
        display: flex;
        flex-direction: column;
      }
    }

    &.small-buy-display {
      display: flex;
      flex-direction: column;
      margin-bottom: 1.5em;

      @include on-tablet {
        display: none;
      }
    }
  }

  .main-display {
    text-align: center;
    margin-bottom: 1.5em;
    @include on-tablet {
      margin-bottom: 2em;
    }
  }

  .main-display > img {
    max-height: 65vh;
    max-width: 100%;
    box-shadow: 7px 8px 19px rgb(59, 58, 57);
  }

  .preview-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: .25em;
  }


  .preview-container__text {
    font-family: $font-family-primary;
    font-size: 0.6em;
    font-weight: bold;
    text-transform: uppercase;
    word-spacing: 0.2em;
    a {
      text-decoration: none;
      color: black;
    }
  }

  .preview {
    img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border: 2px solid #fefefe;
      @include on-desktop {
        width: 50px;
        height: 50px;
      }
      &:hover {
        border: 2px solid #ccc;
        cursor: pointer;
      }
      &.selected {
        border: 2px solid var(--color-primary-one);
      }
    }
  }

  .arrow-down {
    display: inline-block;
    border-radius: 50%;
    border: 1.1px solid black;
    padding: 0.2px 4px;
    margin: 0.7em;
  }

  .large-display {
    width: 100%;
    height: 50vw;
    margin: 2rem 0;
    position: relative;

    @include on-tablet {
      margin: 3rem 0;
    }
    @include on-laptop {
      margin: 4rem 0;
    }
  }

  .large-display > img {
    width: 100%;
    height: 50vw;
    object-fit: cover;
  }

  .large-display__container {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .large-display__container__text {
    color: white;
    max-width: 460px;
    padding: 1.5em;
    opacity: .9;
    @include on-tablet {
      padding: 2em;
    }
    > .title {
      font-family: $font-family-secondary;
      text-transform: uppercase;
      font-size: 0.7em;
    }
    > .desc {
      font-family: $font-family-primary;
      font-size: 1em;
      font-weight: bold;
      padding: 1em 0;
      line-height: 1.3em;
    }
    @include on-tablet {
      font-size: 1.3em;
    }
    @include on-desktop {
      font-size: 1.5em;
    }
  }

  .what-you-get {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1em;
    margin-top: 1rem;

    @include container-sizer;

    @include on-tablet {
      grid-template-columns: 1fr 1fr 1fr;
      gap: 1.5em;
      margin-top: 1.5rem;
    }
    @include on-laptop {
      gap: 3em;
      margin-top: 2rem;
    }
  }

  .wyg-header-1 {
    margin-top: 8px;
    font-family: $font-family-secondary;
    text-transform: uppercase;
    color: var(--color-primary-one);
    font-size: 0.8em;
  }

  .wyg-header-2 > h3 {
    font-family: $font-family-primary;
    color: black;
    font-size: 2em;
    font-weight: 900;
    text-transform: none;
    margin-top: 1em;
    margin-bottom: .5em;

    @include on-tablet {
      margin-top: 1.5em;
    }
  }

  .wyg-header-2 > .desc {
    font-family: $font-family-primary;
    font-size: 0.8em;
    @include on-tablet {
      font-size: 0.9em;
      max-width: 250px;
    }
  }

  .wyg-physical, .wyg-digital {
    margin-top: 1em;
    @include on-tablet {
      margin-top: 0;
    }
  }

  .container {
    display:flex; justify-content: center; flex-direction: column; padding-bottom: 0;
  }

  .align-center {
    display: flex; justify-content: center;
  }

  .icon-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .icon {
    width: 35px;
    height: 35px;
    padding: 0;
  }

  .sub-title {
    padding: 0 1em;
    text-transform: uppercase;
    font-family: $font-family-secondary;
    font-size: 0.8em;
  }

  .art {
    margin-top: 1.5em;
    text-align: center;
  }

  .art > img {
    max-width: 100%;
    height: 50vh;
    @include on-tablet {
      height: inherit;
      max-height: 60vh;
    }
  }

  .text-secondary {
    font-family: $font-family-primary;
    font-size: 0.8em;
    text-align: center;
  }

  .about {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1em;

    @include container-sizer;

    margin-top: 1rem;
    @include on-tablet {
      grid-template-columns: 1fr 1fr;
      gap: 1.5em;
      margin-top: 1.5rem;
    }
    @include on-laptop {
      gap: 3em;
      margin-top: 2rem;
    }
    color: #888;
    .title {
      color: black;
    }
  }

  .about-art  {
    > .title {
      font-family: $font-family-primary;
      font-size: 0.8em;
      font-weight: bold;
      padding-bottom: 1em;
    }
    > .item {
      margin-bottom: 1em;
      @include on-tablet {
        display: flex;
      }
    }
  }

  .about-artist > .title {
    font-family: $font-family-primary;
    font-size: 0.8em;
    font-weight: bold;
    padding-bottom: 1em;
  }


  .about-art .label {
    font-family: $font-family-primary;
    font-size: 0.8em;
    width: 85px;
    margin-bottom: .5em;
    font-weight: bold;
    @include on-tablet {
      margin-bottom: 0;
    }
  }

  .about-art .value {
    font-family: $font-family-primary;
    font-size: 0.8em;
    @include on-tablet {
      width: calc(100% - 85px)
    }
  }

  .about-artist .text {
    font-family: $font-family-primary;
    font-size: 0.8em;
  }
</style>
